/* eslint-disable @typescript-eslint/no-explicit-any */
import { core } from 'types';
import { includes } from 'es-toolkit/compat';
import { toJSON } from '@tock/coretypes';
import { useActions } from 'utils/connect';
import { useMountEffect } from '@tock/hooks';

/**
 * Bootstraps shared logged-in state for every authenticated shell: fetches the
 * patron profile (so email-based checks like isLegalEditorSelector work),
 * refreshes roles from the server (booting anyone without dashboard access), and
 * loads global feature flags.
 *
 * Used by both TockLoggedInRoute (/tock) and the v7 NewRouterRoot so engineers
 * landing on either route tree get identical setup.
 */
export function useLoggedInBootstrap(): void {
  const { actions } = useActions();

  useMountEffect(() => {
    actions.app.fetchLoggedInProfile();
    actions.app.updateAuthenticationRoles().then((response: ProtoResponse<any>) => {
      const roles = toJSON<core.RoleResponse>(response.payload);
      if (
        !includes(roles.role, 'ENG') &&
        !includes(roles.role, 'HOSPITALITY') &&
        !includes(roles.role, 'FINANCE')
      ) {
        actions.app.logout();
        actions.toast.showError("Oops! You don't have access to Tock's dashboard.");
      }
    });
    actions.features.fetchGlobalFeatures();
  });
}
